module.exports = require("@gauzy/plugin-product-reviews");